export default "__VITE_ASSET__brU2IXFR__"